import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { User } from '../../../core/domain/company/company';

export const openAddUserModal = createAction('[Add User Modal] Open Modal');
export const closeAddUserModal = createAction('[Add User Modal] Close Modal');

export const openUserModal = createAction(
  '[User Modal] Open Modal',
  props<{ mode: IFormMode; user?: User }>()
);

export const closeUserModal = createAction('[User Modal] Close Modal');
